

export class Model_CRM_PipeLine {

    public PipeLineStatus: string;
    public PipeLineId: number;
    
}       